import '../css/Header.css';

export default function Header() {
  return (
    <div className="Header">
      <nav id="menu">
        <label htmlFor="tm" id="toggle-menu">MENU <span className="drop-icon">▾</span></label>
        <input type="checkbox" id="tm" />
        <ul className="main-menu clearfix">
          <li><a href="/">NASLOVNA</a></li>
          <li><a href="/vijesti">VIJESTI
        <span className="drop-icon">▾</span>
            <label title="Toggle Drop-down" className="drop-icon" htmlFor="sm1">▾</label>
          </a>
            <input type="checkbox" id="sm1" />
            <ul className="sub-menu">
              <li><a href="/vijesti/regija">REGIJA</a></li>
              <li><a href="/vijesti/varazdin">VARAŽDIN
            <span className="drop-icon">▾</span>
                <label title="Toggle Drop-down" className="drop-icon" htmlFor="sm2">▾</label>
              </a>
                <input type="checkbox" id="sm2" />
                <ul className="sub-menu">
                  <li><a href="#">Item 2.2.1</a></li>
                  <li><a href="#">Item 2.2.2</a></li>
                  <li><a href="#">Item 2.2.3</a></li>
                </ul>
              </li>
              <li><a href="/vijesti/politika">POLITIKA</a></li>
              <li><a href="/vijesti/kultura">KULTURA</a></li>
              <li><a href="/vijesti/sport">SPORT</a></li>
              <li><a href="/vijesti/razno">RAZNO</a></li>
            </ul>
          </li>
          <li><a href="/marketing">MARKETING
        <span className="drop-icon">▾</span>
            <label title="Toggle Drop-down" className="drop-icon" htmlFor="sm3">▾</label>
          </a>
            <input type="checkbox" id="sm3" />
            <ul className="sub-menu">
              <li><a href="/marketing">REGIJA</a></li>
              <li><a href="/cjenik">CJENIK</a></li>
              <li><a href="/slusanost">SLUŠANOST</a></li>
              <li><a href="/reklame-jinglovi">REKLAME I JINGLOVI</a></li>
              <li><a href="/oglasi-cestitke">OGLASI I ČESTITKE</a></li>
            </ul>
          </li>
          <li><a href="/program">PROGRAM
        <span className="drop-icon">▾</span>
            <label title="Toggle Drop-down" className="drop-icon" htmlFor="sm4">▾</label>
          </a>
            <input type="checkbox" id="sm4" />
            <ul className="sub-menu">
              <li><a href="/program">PROGRAM</a></li>
              <li><a href="/emisije">EMISIJE</a></li>
            </ul>
          </li>
          <li><a href="/o-nama">O NAMA
        <span className="drop-icon">▾</span>
            <label title="Toggle Drop-down" className="drop-icon" htmlFor="sm5">▾</label>
          </a>
            <input type="checkbox" id="sm5" />
            <ul className="sub-menu">
              <li><a href="/o-nama">O NAMA</a></li>
              <li><a href="/tim">TIM</a></li>
            </ul>
          </li>
          <li><a href="/kontakt">KONTAKT</a></li>
          <li><a href="https://chopin.bizmusic.net/radio/8030/radio.mp3?1603873293" target="_blank" rel="noreferrer" >RADIO UŽIVO</a></li>
        </ul>
      </nav>
    </div>
  );
}